export default (function trackingService() {
  // tracking service loaded externaly, repo is here : https://github.com/nbcnews/trackingService
  // Ideally this will be an external package that loads the stub

  // Establish the root object, `window` in the browser, or `global` on the server.
  // Server global doesn't have any functionality with tracking server.
  // eslint-disable-next-line no-restricted-globals
  const root = (typeof self === 'object' && self.self === self && self)
    || (typeof global === 'object' && global.global === global && global)
    || this;

  // $t stub v2 expanded and modified to pass eslint
  root.$t = root.$t || (function $t() {
    const stub = function stub(...args) {
      const a = args;
      const retrieveCommand = 'getSaves';
      if (a.length >= 1 && retrieveCommand !== a[0]) {
        stub.storedCommands.push(a);
      }
      return retrieveCommand === a[0] ? stub.storedCommands : '';
    };
    stub.storedCommands = [];
    stub.stub = '2.0';
    return stub;
  }());

  return root.$t;
}());
